import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import useOrgRequestCard from "./useOrgRequestCard";
import CardInfoField from "../../../../../../ui/CardInfoField";
import { Typography } from "@material-ui/core";
import Button from "../../../../../../ui/Button";
import Progress from "../../../../../../ui/Progress";
import {ReactComponent as ClockIconSmall} from "../../../../../../images/state/clock_24.svg";
import { SmallStateIcon, StateTextColor, SmallTypeIcon, TypeLabelBackground } from "../../components/StateStyles";
import Grid from "@material-ui/core/Grid";
import CardPersonBlock from "../../../../../../ui/CardPersonBlock";
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru'
const drawerWidth = 280;

const defaultData = {
  "id" : 0,
  "number" : 0,
  "type" : 0,
  "typeName" : "",
  "date" : "",
  "statusId" : 0,
  "statusName" : "",
  "name" : "",
  "regionName" : "",
  "municipalName" : "",
  "email" : "",
  "phone" : "",
  "okved" : "",
  "site" : "",
  "contractor" : false,
  "customer" : false,
  "employer" : false,
  "personName" : "",
  "personPost" : ""
};

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  hide: {
    display: "none"
  },
  typo: {
    fontSize: 16,
    lineHeight: "24px"
  },
  devider: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "1px dashed #CACCD1"
  },
  typeRequest:{
    background: "#D0101B",
    borderRadius: 10,
    display: "inline-block",
    height: 20,
    width: "auto",
    padding: "0px 8px 0px 0px",
    color: "#FFFFFF",
    '& .svgIcon':{
      width: 20,
      height: 20,
      position: "relative"
    },
    '& .svgFillWhite > g > path': {
      fill: "#ffffff",
      "fill-opacity": 1
    },
    '& .labelText': {
      display: "inline-block",
      lineHeight: "12px",
      fontSize: "10px",
      textTransform: "uppercase",
      position: "relative",
      left: "2px",
      top: "-6px"
    }
  },
  stateBlock: {
    marginTop: 16,
    marginBottom: 8,
    height: 20,
    display: "flex",
    flexDirection: "column",
    width: "220px",
    boxSizing: "border-box"
  },
  stateLabel: {
    textAlign: "left",
    position: "absolute",
    display: "inline-block",
    height: 20,
    width: "auto",
    padding: "0px 8px 0px 0px",
    background: 'rgba(48,73,103,0.8)',
    color: '#ffffff',
    borderRadius: 10,
    '& .svgIcon':{
      width: 20,
      height: 20,
      position: "relative"
    },
    '& .svgFillWhite > g > path': {
      fill: "#ffffff",
      "fill-opacity": 1
    },
    '& .labelText': {
      display: "inline-block",
      lineHeight: "12px",
      fontSize: "10px",
      textTransform: "uppercase",
      position: "relative",
      left: "2px",
      top: "-6px"
    }
  },
  more: {
    marginTop: 24,
    marginBottom: 80,
    display: "flex",
    justifyContent: "center"
  },
  cardTitle: {
    display: "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
    "text-align": "center",
    height: "160px",
    background: "#E9ECF7",
    border: "2px solid #CACCD1",
    fontSize: "14px",
    lineHeight: "18px",
    '& .requestNumber':{
      width: "160px",
      color: "#596E79"
    },
    '& .orgName':{
      paddingTop: "8px",
      width: "160px",
      'word-wrap': 'true',
      'overflow-wrap': "break-word",
      lineHeight: "20px",
      fontSize: "16px",
      color: "#000000"
    }
  },
  rolesBlock:{
    textAlign: "left",
    position: "absolute",
    display: "inline-block",
    height: 20,
    width: "auto"
  },
  roleName:{
    height: "20px",
    width: "20px",
    marginRight: "8px",
    padding: "4px 6px",
    background: "#596E79",
    'text-align': 'center',
    "border-radius": "10px",
    display: "inline-block",
    "justify-content": "center",
    "align-items": "center",
    "font-weight": 600,
    "font-size": "12px",
    "line-height": "14px",
    color: "#FFFFFF"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  /*drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000,
    [theme.breakpoints.down("md")]: {
      position: "fixed"
    }
  },*/
  drawerOpen: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 1000
  },
  drawerClosed: {
    width: 0
  },
  drawerPaper: {
    width: drawerWidth,
    boxSizing: "border-box",
    top: 65
  },
  drawerPaperContent: {
    boxSizing: "border-box",
    padding: 20
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginRight: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: 0
  },
  closeButton: {
    position: 'absolute',
    opacity: 0.5,
    height: 24,
    'text-align': 'left',
    display: "flex",
    alignItems: "flex-start",
    '& .MuiIconButton-root':{
      padding: 0
    }
}
}));

const formatDate = date =>
    date ? format(parseISO(date), "dd.MM.yy", { locale: ru }) : null;

const OrgRequestDrawer = ({ open, reqId, history, hideLink, handleDrawerClose }) => {
  const classes = useStyles();
  const { requestCard, getRequestCard } = useOrgRequestCard();

  React.useEffect(() => {
    if (reqId !== -1) {
      getRequestCard(reqId);
    }
  }, [reqId]);

  const onLinkClick = () => {
    history.push(`/work/app/manage/resources/org/requests/${requestCard.id}`);
  };

  return (
    <Drawer
      className={open ? classes.drawerOpen : classes.drawerClosed}
      variant="persistent"
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <div>
        {!hideLink && <div className={classes.closeButton}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronRightIcon/>
          </IconButton>
        </div>}
      {requestCard ? (
        <div className={classes.drawerPaperContent}>
          <div className={classes.cardTitle}>
            <Typography className="requestNumber" align="center">
              {`№${requestCard.number} от ${formatDate(requestCard.date)}`}
            </Typography>
            <div style={{"width":"160px", "height":"80px", "display":"block"}}>
            <Typography className="orgName" align="center">
              {requestCard.name}
            </Typography>
            </div>
            <Typography align="center">
              <div className={classes.typeRequest}>
                {SmallTypeIcon(requestCard.type, "svgIcon svgFillWhite")}
                <div className="labelText">{(requestCard.type == 0) ? "регистрация" : "изменение"}</div>
              </div>
            </Typography>
          </div>


          <div className={classes.stateBlock}>
            <Grid container direction="row" justify="space-between" alignItems="center">
              <Grid item xs={6}>
                <div className={classes.rolesBlock}>
                {requestCard.contractor && <div className={classes.roleName} title="Подрядчик">П</div>}
                {requestCard.customer && <div className={classes.roleName} title="Заказчик">З</div>}
                {requestCard.employer && <div className={classes.roleName} title="Работодатель">Р</div>}
                </div>
              </Grid>
              <Grid item xs={6}>
                  <div style={{"background": StateTextColor(requestCard.statusId), "right": "20px"}} className={classes.stateLabel}>
                    {SmallStateIcon(requestCard.statusId, "svgIcon svgFillWhite")}
                    <div className="labelText">{requestCard.statusName}</div>
                  </div>
              </Grid>
          </Grid>
          </div>
          <div className={classes.devider}></div>

          {requestCard.municipalName && <CardInfoField field="Город:" value={requestCard.municipalName} />}
          <CardInfoField field="ОКВЭД:" value={requestCard.okved} />
          <CardInfoField field="Телефон:" value={requestCard.phone} />
          <CardInfoField field="E-mail:" value={requestCard.email} />
          <div className={classes.devider}></div>

          <div style={{ "marginTop": 16, "fontSize": 12 }}>
            <Typography style={{ "display": "block"}}
              variant="caption"
              color="textSecondary">
              Представитель:
            </Typography>
            <div style={{ "display": "block"}}>
              <CardPersonBlock name={requestCard.personName} desc={requestCard.personPost}/>
            </div>
          </div>

          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
        </div>
      ) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
      </div>
    </Drawer>
  );
};

export default withRouter(OrgRequestDrawer);
